import PropTypes from 'prop-types';

export const provisionQualityPropTypes = PropTypes.shape({
  calcErrorCount: PropTypes.number,
  name: PropTypes.string,
  readyToTax: PropTypes.number,
  successComplete: PropTypes.number,
  successPercent: PropTypes.number,
  trialBalanceNotReceivedCount: PropTypes.number,
  validErrorCount: PropTypes.number,
});
